export const sebab = {
  router: [
    {
      name: "SEBAB",
      key: "sebab",
      path: "/admin/master/sebab",
      apiUrl: {
        data: "master/api/sebab/",
        preview: "master/api/sebab/",
      },
      breadCrumb: [
        {
          label: "MASTER",
          link: "#",
          active: false,
        },
        {
          label: "SEBAB",
          link: "#",
          active: true,
        },
      ],
      component: "datatable1",
    },
  ],
  model: [
    {
      name: "id",
      isPk: true,
      isForm: false,
      isTable: false,
    },
     {
      name: "kode",
      label: "Kode",
      type: "text",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi",
          },
        ],
      },
      isForm: true,
      isTable: true,
    },
    {
      name: "nama",
      label: "Nama",
      type: "text",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi",
          },
        ],
      },
      isForm: true,
      isTable: true,
    },
  ],
};
